<style lang="scss">

  .main {
    padding: 0.5rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  p, h1 {
    margin: 0;
  }

  .title {
    text-align: center;
    font-size: 28px;
    margin-bottom: 1rem;
  }

  .subtitle {
    text-align: center;
    margin-bottom: 2.5rem;
    background-color: #A5C641;
    color: white;
    padding: 4px 20px;
    font-weight: 400;
    font-size: 16px;
  }

  .foot {
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  @media only screen and (max-width: 600px) {
    .foot {
      flex-direction: column;
      align-items: center;
      gap: 0.75rem
    }
  }

  .foot__author {
    color: #242424;
    font-size: 16px;
  }

  .foot__author a {
    color: #242424;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .foot__link {
    color: #7e7e7e;
    font-size: 16px;
    text-decoration: none;

    &:hover {
      color: #242424;
      text-decoration: underline;
    }
  }

  .logo {
    position: absolute;
    bottom: 26px;
  }


  .logo__lba {
    left: 0;
    height: 28px;
  }

  .logo__sfapec {
    right: 0;
    height: 46px;
  }

  @media only screen and (max-width: 600px) {
    .logo {
      display: none;
    }
  }


</style>

<div class="main">
    <h1 class="title">Responsabilité Civile Professionnelle SFAPEC</h1>
    <h4 class="subtitle">Formulaire de souscription</h4>

    <div class="foot">
        <p class="foot__author">Proposé par <a href="https://www.lbaconseil.fr/" target="_blank">LBA Courtage</a></p>
        <a class="foot__link"
           href="files/SFAPEC_garanties.pdf"
           target="_blank">Visionner les garanties</a>


        <img class="logo logo__lba" src="files/logo_lba.png"/>
        <img class="logo logo__sfapec" src="files/logo_sfapec.png"/>
    </div>
</div>
